// extracted by mini-css-extract-plugin
export default {"container":"InAppGuide_container__3tk+u","openBtn":"InAppGuide_openBtn__JBgDU","keepBtn":"InAppGuide_keepBtn__j6iT5"};